import { useEffect } from 'react';
import { signIn } from '@mirats/mirats-auth';

function LoginRedirect() {
  useEffect(() => {
    signIn();
  }, []);

  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '50vh',
      }}
    >
      <h1>Redirecting to login...</h1>
    </div>
  );
}

export default LoginRedirect;
